<template>
  <div class="devon__carousel">
    <carousel navigation-enabled
              autoplay
              :navigation-prev-label="labels.previous"
              :navigation-next-label="labels.next"
              :per-page="1">
      <slide v-for="(slide, index) in slides"
             :key="`Slide: ${index}`">
        <div class="devon__carousel-image-wrapper">
          <img :src="slide.backgroundImageSrc"
               alt="img">
        </div>

        <div class="devon__carousel-content">
          <p>{{ slide.description }}</p>
          <div v-if="slide.cta">
            <a :href="slide.cta.url"
               :target="slide.cta.target"
               class="btn btn-accent-1">
              {{ slide.cta.name }}
              <font-awesome-icon :icon="['fas', 'chevron-right']"></font-awesome-icon>
            </a>
          </div>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {
  name: "DevonCarousel",
  props: {
    slides: {
      type: Array,
      default: () => [],
      validator ( slides ) {
        return slides.every( slide => Object.keys( slide ).every(
          key => ["heading", "description", "backgroundImageSrc", "cta"].includes( key.toLowerCase() ) )
        );
      }
    }
  },
  data: () => ( {
    labels: {
      previous: "<i class='fas fa-chevron-left'></i>",
      next: "<i class='fas fa-chevron-right'></i>"
    }
  } )
};
</script>

<style scoped lang="less">
.devon {
  &__carousel {
    @navigation-button-size: 50px;
    @dot-size: 20px;
    @dot-active-shadow: 10px;
    max-width: 1310px;

    /deep/ .VueCarousel {
      &-pagination {
        position: absolute;
        bottom: 0;
      }

      &-dot {
        &-container {
          display: flex;
          justify-content: center;
          gap: 40px;
          margin-bottom: 40px;
        }

        width: @dot-size !important;
        height: @dot-size !important;
        padding: 0 !important;;
        background-color: rgba(255, 255, 255, 0.75) !important;

        &--active {
          box-shadow: 0 0 0 @dot-active-shadow rgba(255, 255, 255, 0.5) !important;

          @media ( max-width: 991px ) {
            box-shadow: 0 0 0 calc( @dot-active-shadow / 2 ) rgba(255, 255, 255, 0.5) !important;
          }
        }

        @media ( max-width: 991px ) {
          width: calc( @dot-size * 0.75 ) !important;
          height: calc( @dot-size * 0.75 ) !important;
        }
      }

      &-slide {
        display: flex;
        justify-content: center;
        align-content: center;
        height: 450px;
      }

      &-navigation {
        @media ( max-width: 991px ) {
          position: relative;
        }
      }

      &-navigation-button {
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
        padding: 10px;
        border-radius: 100%;
        width: @navigation-button-size;
        height: @navigation-button-size;
        display: flex;
        justify-content: center;
        align-items: center;

        @media ( max-width: 991px ) {
          position: absolute;
          top: -400px;
          z-index: 1;
          width: calc( @navigation-button-size * 0.8 );
          height: calc( @navigation-button-size * 0.8 );
        }
      }

      &-navigation-prev {
        left: 100px;
      }

      &-navigation-next {
        right: 100px;
      }
    }

    &-image-wrapper {
      position: absolute;
      width: 100%;
      height: 450px;

      //.gradient {
      //  width: 100%;
      //  height: 100%;
      //  background: linear-gradient(grey, transparent);
      //}

      &:after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: inline-block;
        background: linear-gradient(transparent, rgba(0, 0, 0, 0.5));
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      z-index: 10;
      color: #fff;
      width: 75%;
      padding-right: 30px;

      h2, h3, h4, h5, h6 {
        color: #fff;
        font-size: 36px;
      }

      p {
        font-size: 24px;
        font-weight: 600;
        margin: 0;
      }

      a {
        margin-top: 1rem;
        border: 1px solid #fff;
        border-radius: 5px;

        svg {
          margin-left: 0.25rem;
        }
      }
    }

  }
}
</style>
